import { render, staticRenderFns } from "./QualityValue.vue?vue&type=template&id=167494c2&scoped=true&"
var script = {}
import style0 from "./QualityValue.vue?vue&type=style&index=0&id=167494c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167494c2",
  null
  
)

export default component.exports